<template>
  <div class="item-detail">
    <van-skeleton v-if="!firstloading" title :row="5" style="background-color:#fff;padding:20px" />
    <div class="form-body" v-else>
      <div class="help-right" @click="help_show = true">
        <img src="../../../static/images/icon/icon-help.png" alt class="help-icon" />
        <!-- <div class="help-text">帮助</div> -->
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item title="基本设置" icon="label-o" name="1">
          <div class="form-row">
            <div class="form-row-title">
              活动名称
              <span class="small">仅用于后台区分活动</span>
            </div>
            <van-field v-model="item.coupon_title" placeholder="请输入活动名称" border />
          </div>

          <div class="form-row">
            <div class="form-row-title">
              对外活动名称
              <span class="small">用户端显示的活动名称</span>
            </div>
            <van-field v-model="item.pub_title" placeholder="请输入对外活动名称" border />
          </div>

          <div class="form-row">
            <div class="form-row-title">
              活动关键词
              <span class="small">公众号回复关键词可弹出海报，仅限一个关键词且勿与其他活动重复</span>
            </div>
            <van-field v-model="item.join_keyword" placeholder border />
          </div>

          <div class="form-row">
            <div class="form-row-title">
              活动时间
              <span class="small"></span>
            </div>
            <div class="field">
              <van-field
                v-model="item.coupon_begindate"
                placeholder="请选择开始时间"
                border
                readonly
                clickable
                @click="seltime(1)"
              />
              <span>至</span>
              <van-field
                v-model="item.coupon_expdate"
                placeholder="请选择结束时间"
                border
                readonly
                clickable
                @click="seltime(2)"
              />
            </div>
          </div>

          <div class="form-row" v-show="false">
            <div class="form-row-title">
              活动礼品数量限制
              <span class="small">填0不限制，当库存为减少为1时，系统会暂停活动</span>
            </div>
            <van-field v-model="item.coupon_total" type="number" placeholder="请输入活动礼品数量限制" border />
          </div>

          <div class="form-row"  v-show="false">
            <div class="form-row-title">
              单个用户赠送礼品数量限制
              <span class="small">填0不限制</span>
            </div>
            <van-field
              v-model="item.coupon_user_total"
              type="number"
              placeholder="请输入单个用户赠送礼品数量限制"
              border
            />
          </div>
        </van-collapse-item>
        <van-collapse-item title="海报设置" icon="photo-o" name="2">
          <div class="form-row">
            <div class="form-row-title">
              裂变海报设置
              <span class="small">推荐海报尺寸：1080*1920px</span>
            </div>
            <div class="sm-title" v-if="posterupload_result">海报已经上传，点击下方按钮可修改！</div>
            <van-button
              type="primary"
              size="small"
              class="btn-uploadposter"
              v-if="posterupload_result"
              @click="poseter_module"
            >修改海报</van-button>
            <van-button type="primary" size="small" class v-else @click="poseter_module">上传海报</van-button>
          </div>

          <div class="form-row">
            <div class="form-row-title">
              老用户获取海报提示语
              <span class="small">用户获取自己的专属裂变海报时，会弹出以下文字提示</span>
            </div>
            <van-field
              v-model="item.rank_rule"
              placeholder="请输入老用户获取海报的提示语"
              rows="5"
              type="textarea"
              maxlength="500"
              show-word-limit
              border
            />
          </div>

          <div class="form-row">
            <div class="form-row-title">
              邀请好友参考话术
              <span class="small"></span>
            </div>
            <van-field
              v-model="item.share_words"
              placeholder="请输入邀请好友参考话术"
              rows="5"
              type="textarea"
              maxlength="500"
              show-word-limit
              border
            />
          </div>
        </van-collapse-item>
        <van-collapse-item title="新用户添加企业微信好友设置" icon="apps-o" name="3">
          <div class="form-row">
            <div class="form-row-title">
              选择指定添加人（可多选）
              <span class="small">多选后随机分配，注意：若修改使用人需重新获取二维码</span>
            </div>
            <van-field
              v-if="useuser.loading"
              placeholder="请选择指定添加人（可多选）"
              readonly
              clickable
              @click="seluseuserEvent"
              :value="getUserName"
            />
          </div>

          <div class="form-row">
            <div class="form-row-title">
              自动通过好友
              <span class="small">开启后，客户通过此二维码扫码加您好友无需您同意</span>
            </div>
            <van-switch v-model="item.auto_firend" />
          </div>
          <div class="form-row">
            <div class="form-row-title">
              自动打招呼
              <span class="small"></span>
            </div>
            <van-switch v-model="item.auto_sayhi" />
          </div>
          <div class="form-row" v-if="item.auto_sayhi">
            <div class="form-warning">
              <img src="../../../static/images/icon/icon-warning-h.png" alt />
              因企业微信限制，若您的企业已经在"企业微信后台"配置了欢迎语，这里的打招呼将不会生效
              <a
                href="javascript:void(0);"
                @click="preview(require('../../../static/images/help-autohi.png'))"
              >查看解释</a>
            </div>
            <div class="form-row-title">
              打招呼内容
              <span class="small"></span>
            </div>
            <van-tabs
              v-model="hi_content_tab"
              style="border:1px solid #ebedf0; background-color:#fafafa"
            >
              <van-tab title="文字" name="a" class="pd15">
                <div class="form-row">
                  <div class="form-row-title">
                    文本内容
                    <span class="small"></span>
                  </div>
                  <van-field
                    v-model="item.hi_content.text.content"
                    rows="3"
                    type="textarea"
                    maxlength="500"
                    placeholder="请输入打招呼的内容"
                    show-word-limit
                    border
                  />
                </div>
              </van-tab>
              <van-tab title="文字+图片" name="b" class="pd15">
                <div class="form-row">
                  <div class="form-row-title">
                    文本内容
                    <span class="small">若不输入，则只回复图片</span>
                  </div>
                  <van-field
                    v-model="item.hi_content.text.content"
                    rows="3"
                    type="textarea"
                    maxlength="500"
                    placeholder="请输入打招呼的内容"
                    show-word-limit
                    border
                  />
                </div>
                <div class="form-row">
                  <div class="form-row-title">
                    图片内容
                    <span class="small"></span>
                  </div>
                  <van-uploader
                    name="imager_vantuploader"
                    @click-preview="clickpreview"
                    :before-read="beforeRead"
                    :after-read="afterRead"
                    v-model="image_vant"
                    :preview-full-image="false"
                    :max-count="1"
                  />
                </div>
              </van-tab>
              <van-tab title="文字+图文链接" name="c" class="pd15">
                <div class="form-row">
                  <div class="form-row-title">
                    文本内容
                    <span class="small">若不输入，则只回复图文链接</span>
                  </div>
                  <van-field
                    v-model="item.hi_content.text.content"
                    rows="3"
                    type="textarea"
                    maxlength="500"
                    placeholder="请输入打招呼的内容"
                    show-word-limit
                    border
                  />
                </div>
                <div class="form-row">
                  <div class="form-row-title">
                    赠礼链接标题
                    <span class="small"></span>
                  </div>
                  <van-field v-model="item.hi_content.link.title" placeholder="请输入链接标题" border />
                </div>
                <div class="form-row">
                  <div class="form-row-title">
                    赠礼链接描述
                    <span class="small"></span>
                  </div>
                  <van-field v-model="item.hi_content.link.desc" placeholder="请输入图文链接描述" border />
                </div>
                <div class="form-row">
                  <div class="form-row-title">
                    赠礼链接小图标
                    <span class="small"></span>
                  </div>
                  <van-uploader
                    name="link_vantuploader"
                    :before-read="beforeRead"
                    :preview-full-image="false"
                    :after-read="afterRead"
                    :max-count="1"
                    @click-preview="clickpreview"
                    v-model="link_vant"
                  />
                </div>
                <div class="form-row">
                  <div class="form-row-title">
                    赠礼链接地址
                    <span class="small"></span>
                  </div>
                  <van-field v-model="item.hi_content.link.url" placeholder="请输入图文链接地址" border />
                </div>
              </van-tab>
            </van-tabs>
          </div>
          <div class="form-row">
            <div class="form-row-title">
              自动打标签
              <span class="small"></span>
            </div>
            <van-switch v-model="item.auto_tab" />
          </div>
          <div class="form-row" v-if="item.auto_tab">
            <div class="form-row-title">
              标签内容
              <span class="small"></span>
            </div>
            <van-field
              readonly
              clickable
              :value="getTabName"
              placeholder="点击选择标签内容"
              right-icon="arrow-down"
              @click="userTabs_sel = true"
            />
          </div>
        </van-collapse-item>
        <van-collapse-item title="冲榜奖励设置" icon="medal-o" name="4">
          <div class="form-row">
            <div class="form-row-title">
              活动说明
              <span class="small">该说明将会展示在用户影响力排行榜处</span>
            </div>
            <van-field
              v-model="item.giftrule"
              placeholder="恭喜您获得了10张伙伴猫VIP会员亲友月卡大礼包！将下方您的专属赠礼海报分享到朋友圈/微信群/私聊对话，邀请他们扫码即可领取啦~

赠人玫瑰，手留余香，赠送好友人数越多，您还将获得以下奖励：
1、好友收下您赠送的VIP会员月卡开通使用后，你和Ta都将会获得一个月的VIP会员使用权，赠送时长可叠加。
2、赠送满【5】人，即可免费加入企业微信研究小群
3、赠送满【10】，即可免费获得伙伴猫冲榜裂变系统2个月使用权"
              rows="5"
              type="textarea"
              maxlength="500"
              show-word-limit
              border
            />
          </div>
          <div class="tab-title">奖品设置</div>
          <div class="tab-head">
            <div
              v-for="(gift,index) in giftlist"
              :key="index"
              :class="'tab-head-item'+(gift.active==1?' active':'')"
              @click="selgift(index)"
            >奖品{{index+1}}</div>
            <div class="tab-head-item tab-head-new" @click="addgift">
              <van-icon name="plus" />添加奖品
            </div>
          </div>
          <template v-for="(gift,index) in giftlist">
            <div class="tab-content" :key="index" v-show="gift.active==1">
              <a href="javascript:void(0)" class="tab-content-del" @click="delgift(index)">删除这个奖励</a>
              <div class="form-row">
                <div class="form-row-title">
                  冲榜奖品设置
                  <span class="small"></span>
                </div>

                <div class="field">
                  <span class="field-title">奖品名称</span>
                  <van-field v-model="gift.name" placeholder="请输入奖品名称" border />
                </div>
                <div class="field">
                  <span class="field-title">奖品数量</span>
                  <van-field v-model="gift.amount" placeholder="请输入奖品数量" type="number" border />
                </div>
                <div class="field">
                  <span class="field-title">派奖模式</span>
                  <van-field
                    right-icon="arrow-down"
                    border
                    readonly
                    clickable
                    :value="gift.typename"
                    placeholder="请选择派奖模式"
                    @click="gifttype_showevent(index)"
                  />
                </div>
                <div class="field" v-show="gift.type==1">
                  <span class="field-title">排名前</span>
                  <van-field v-model="gift.winrank" type="number" border placeholder="请输入排名" />
                  <span>获奖</span>
                </div>
                <div class="field" v-show="gift.type==2">
                  <span class="field-title">达标人数</span>
                  <van-field v-model="gift.wincount" type="number" border placeholder="请输入达标人数" />
                  <span>获奖</span>
                </div>
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  中奖通知
                  <span class="small"></span>
                </div>
                <van-field
                  v-model="gift.winnotice"
                  placeholder="请输入中奖通知"
                  rows="4"
                  type="textarea"
                  maxlength="50"
                  show-word-limit
                  border
                />
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  领奖图片
                  <span class="small">可上传兑奖人微信二维码，或者其他兑奖二维码</span>
                </div>
                <van-uploader
                  name="link_vantuploader"
                  :before-read="beforeRead"
                  :preview-full-image="false"
                  :after-read="afterRead"
                  :max-count="1"
                  @click-preview="clickpreview"
                  v-model="gift.image_vant"
                />
              </div>
            </div>
          </template>
        </van-collapse-item>
        <van-collapse-item title="活动结束设置" icon="failure" name="5">
          <div class="form-row">
            <div class="form-row-title">
              活动结束提示语
              <span class="small"></span>
            </div>
            <van-field
              v-model="item.err_text"
              placeholder="请输入活动结束提示语"
              rows="5"
              type="textarea"
              maxlength="500"
              show-word-limit
              border
            />
          </div>

          <div class="form-row">
            <div class="form-row-title">
              联系人企业微信名片码
              <span class="small"></span>
            </div>
            <van-uploader
              name="link_vantuploader"
              :before-read="beforeRead"
              :preview-full-image="false"
              :after-read="afterRead"
              :max-count="1"
              @click-preview="clickpreview"
              v-model="errimage_vant"
            />
          </div>
        </van-collapse-item>
      </van-collapse>
      <van-button
        type="primary"
        block
        style="margin-top:15px"
        @click="subdata"
        :loading="loading_sub"
        loading-text="数据提交中..."
      >发布活动</van-button>

      <van-button
        type="info"
        :loading="loading_qrc"
        loading-text="数据提交中..."
        block
        style="margin-top:20px"
        @click="DownLoadQrCode"
      >保存并下载活动参与二维码</van-button>
    </div>

    <van-popup v-model="posterupload_show" position="bottom">
      <div class="popup-menu">
        <div class="popup-menu-content"></div>
        <a href="javascript:void(0);" class="fright cancel" @click="posterupload_show = false">取消</a>
      </div>
      <wx_poster @callback="poster_module_enter" v-if="posterupload_show"></wx_poster>
    </van-popup>
    <!-- <van-popup v-model="posterupload_show" position="bottom">
      <div class="poster-box">
        <div class="head">
          <div class="row text-left">
            <a href="javascript:void(0)" class="cancel" @click="poster_cancel">取消</a>
          </div>
          <div class="row text-right">
            <a href="javascript:void(0)" class="enter" @click="poster_enter">确认</a>
          </div>
        </div>
        <div class="poster-img">
          <van-uploader
            name="link_vantuploader"
            :before-read="beforeRead_poster"
            :after-read="afterRead_poster"
            :max-count="1"
          >
            <img
              :src="posterupload_wait[0].url"
              alt
              v-if="posterupload_wait && posterupload_wait.length>0"
            />
            <img src="../../../static/images/poster_tem.png" alt v-else />
          </van-uploader>
        </div>
        <van-uploader
          class="upload-poster"
          name="link_vantuploader"
          :before-read="beforeRead_poster"
          :after-read="afterRead_poster"
          :max-count="1"
        >
          <van-button
            type="info"
            loading-text="上传中..."
            block
            :loading="posterupload_loading"
            class="btn-upload-poster"
          >上传海报</van-button>
        </van-uploader>
      </div>
    </van-popup>-->
    <van-popup v-model="vanttime_show" position="bottom">
      <van-datetime-picker
        v-model="nowDate"
        type="datetime"
        title="请选择时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="vanttime_confirm"
        @cancel="vanttime_cancel"
      />
    </van-popup>
    <van-popup v-model="userTabs_sel" position="bottom" :style="{ height: '70%' }">
      <wx_tags :userTabs="userTabs" v-if="userTabs_sel"></wx_tags>
    </van-popup>
    <van-popup v-model="useuser_sel" position="bottom" :style="{ height: '70%' }">
      <wx_users :useuser="useuser" v-if="useuser_sel && !hasdept"></wx_users>
      <wx_usersn :useuser="useuser" v-if="useuser_sel && hasdept"></wx_usersn>
    </van-popup>

    <van-popup v-model="help_show" position="bottom">
      <div class="popup-menu">
        <div class="popup-menu-content"></div>
        <a href="javascript:void(0);" class="fright cancel" @click="help_show = false">关闭</a>
      </div>
      <iframe
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        style="margin: 0 auto;width: 100%;height: 90vh;"
        allowtransparency="yes"
        src="https://www.wobei666.com/shiyongjiaocheng/3408.html"
      ></iframe>
    </van-popup>

    <van-action-sheet
      v-model="gifttype_show"
      :actions="gifttype_actions"
      @select="gifttype_selevent"
    />
  </div>
</template>

<script>
import config from "@/config";
import Vue from "vue";
import wx_tags from "../Tags";
import wx_usersn from "../SelUserN";
import wx_users from "../SelUser";
import wx_poster from "../poster/posteredit";
import { newname } from "@/util/crypto";
import { ImagePreview } from "vant";
import {
  Button,
  Field,
  Switch,
  Picker,
  Popup,
  Tabs,
  Tab,
  Panel,
  Uploader,
  Toast,
  Skeleton,
  Dialog,
  DatetimePicker,
  Collapse,
  CollapseItem,
  ActionSheet,
  
} from "vant";

Vue.use(ActionSheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Button);
Vue.use(Field);
Vue.use(Switch);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Panel);
Vue.use(Uploader);
Vue.use(Toast);
Vue.use(Skeleton);
Vue.use(Dialog);
Vue.use(DatetimePicker);
export default {
  name: "item-detail",
  data() {
    return {
      gifttype_index: 0,
      gifttype_show: false,
      gifttype_actions: [
        { name: "按排名获奖", id: 1 },
        { name: "按完成邀请人数获奖", id: 2 },
      ],

      firstloading: false,
      loading_sub: false,
      unitloading: false,
      units: [],
      selunit: false,
      gifttypeloading: false,
      gifts: [],
      selgifttype: false,

      //图文消息图片
      image_vant: [],
      //图文链接图片
      link_vant: [],

      activeNames: ["1"],
      item: {
        channelid: 0,
        channel_name: "",
        pub_title: "",
        auto_gift: 0,
        gifttype: true,
        giftunit: true,
        giftcount: 0,
        giftdesc: "",
        remark: "",
        auto_firend: true,
        auto_sayhi: true,
        useuser: "",
        tab_content: [],
        hi_content: {
          text: {
            content:
              "嗨，你好呀，我是私域增长圈的负责人小潘，你的朋友花了99元为你购买了《3节私域增长线上课》，下方是课程的优惠券，你点击领取后即可0元兑换课程了哟~",
          },
          image: {
            media_path: "",
          },
          link: {
            title: "",
            picurl: "",
            desc: "",
            url: "",
          },
        },
        auto_tab: true,

        rank_rule: `你好呀，#昵称# 

欢迎参加私域增长圈的送礼PK活动，参与方式如下：

将下方您的专属赠礼海报分享到朋友圈/微信群/私聊对话，邀请他们扫码领取《3节私域增长线上课》啦~可参考以下赠送话术

赠人玫瑰，手留余香，赠送好友人数越多，您还将获得以下奖励：
1、赠送好友【5】人，您可免费加入企业微信研究小群
2、排行榜前【10】名，可获得伙伴猫送礼裂变锁客系统3个月使用权
3、排行榜前【3】名，可获得伙伴猫送礼裂变锁客系统一年使用权

点击下方蓝字查看影响力排行榜
↓↓↓↓↓↓

#影响力排行榜# `,
        share_words: `今天在广州学习私域增长线下课，1天学费1399，半天就已经值回票价了。

为了跟阿may老师有进一步的沟通，我买了10份阿may老师的99元私域增长线上课送给大家，已经买单了，免费送给我身边的朋友，需要的话，快扫码领取，只免费到今天晚上8点，收下这份礼物就是帮了我一个忙，真心感谢~`,
        err_text: `不好意思，你来晚了，我们的活动已经结束了。

请扫码添加下方小潘老师企业微信，送你一份阿may老师整理的万字企业微信运营手册`,
      },
      //图文消息图片
      image_vant: [],
      //图文链接图片
      link_vant: [],
      //活动结束上传文案
      errimage_vant: [],
      //显示使用人下拉框
      useuser_sel: false,
      useuser_data: [],
      useuser: {
        datas: [],
        seldatas: [],
        closeModal: function () {},
        loading: false,
      },
      //打招呼方式b
      hi_content_tab: "c",
      //标签相关
      userTabs: {
        seltag: [],
        datas: [],
        confimEvent: function () {},
      },

      userTabs_sel: false,
      //渠道ID
      channelid: 0,
      isdefault: false,
      loading_sub: false,
      loading_qrc: false,
      channeltype: 0,

      hasdept: false,
      //当前选择时间的是哪个组件 1开始 2结束时间
      vanttime_item: 1,
      //是否显示时间选择组件
      vanttime_show: false,

      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      nowDate: new Date(),

      //海报上传界面是否显示
      posterupload_show: false,
      posterupload_result: null,
      posterupload_wait: null,
      posterupload_loading: false,

      help_show: false,

      giftlist: [],
    };
  },
  methods: {
    //打开选项
    gifttype_showevent(index) {
      this.gifttype_index = index;
      this.gifttype_show = true;
    },
    //选择某个奖项
    gifttype_selevent(item) {
      this.giftlist[this.gifttype_index].type = item.id;
      this.giftlist[this.gifttype_index].typename = item.name;
      this.gifttype_show = false;
    },
    //选择某个奖项
    selgift(selindex) {
      var t = this;
      for (let index = 0; index < t.giftlist.length; index++) {
        const element = t.giftlist[index];
        if (t.giftlist[index].active == 1) t.giftlist[index].active = 0;
      }
      t.giftlist[selindex].active = 1;
    },
    //添加奖品
    addgift() {
      var t = this;
      for (let index = 0; index < t.giftlist.length; index++) {
        const element = t.giftlist[index];
        if (t.giftlist[index].active == 1) t.giftlist[index].active = 0;
      }
      t.giftlist.push({
        name: "",
        amount: "",
        type: 1,
        typename: "按排名获奖",
        wincount: "",
        winrank: "",
        winnotice: "",
        image_vant: [],
        active: 1,
      });
    },
    //删除这个奖品
    delgift(index) {
      var t = this;
      Dialog.confirm({
        message: "确认删除这个奖品吗？",
      })
        .then(() => {
          t.giftlist.splice(index, 1);
          if (index >= t.giftlist.length) index--;
          if (index >= 0) t.giftlist[index].active = 1;
        })
        .catch(() => {
          // on cancel
        });
    },
    preview(url) {
      ImagePreview({
        images: [url],
        closeable: true,
        closeOnPopstate: true,
      });
    },
    //下载活动二维码
    DownLoadQrCode() {
      var t = this;
      //提交数据，并下载二维码
      t.subdata(() => {
        t.GetBindCorp((error, corpinfo) => {
          if (corpinfo) {
            t.$router.push({
              path: "/mcoupon/info",
              query: { id: t.item.coupon_id },
            });
          } else
            Dialog.alert({
              message:
                "尚未绑定微信服务号，无法生成活动参与二维码。\r\n\r\n首次使用冲榜裂变功能，需要您的微信服务号授权伙伴猫，请点击下方按钮进入授权设置",
              confirmButtonText: "马上授权",
              showCancelButton: true,
              messageAlign: "left",
            })
              .then(() => {
                t.$router.push({
                  path: "/set/wpubstep1",
                });
              })
              .catch(() => {});
        });
      });
    },
    //获得当前账号绑定的公众号信息
    GetBindCorp(callback) {
      var t = this;
      var url = `/user/GetBindCorp`;
      var params = {};
      t.corpinfo = null;
      t.$http
        .get(url, params, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.corpinfo = res.Data;
          } else {
          }
          typeof callback == "function" && callback(res.errorMsg, res.Data);
        })
        .catch((error) => {
          console.log(error);
          typeof callback == "function" && callback(error);
        });
    },
    //提交数据
    subdata(callback) {
      var t = this;
      var params = JSON.parse(JSON.stringify(t.item));
      //#region 数据合法性验证
      if (!t.useuser.seldatas || t.useuser.seldatas.length <= 0) {
        Toast("请选择指定使用人");
        return;
      }

      if (!t.posterupload_result) {
        Toast("请上传送礼海报");
        return;
      }

      if (!t.errimage_vant || t.errimage_vant.length <= 0) {
        Toast("请上传联系人企业微信名片码");
        return;
      }
      if (params.auto_sayhi) {
        var hi_content = params.hi_content;
        console.log("t.hi_content_tab", t.hi_content_tab);
        console.log("hi_content", hi_content);
        //数据处理
        switch (t.hi_content_tab) {
          case "a":
            if (
              !hi_content.text ||
              !hi_content.text.content ||
              hi_content.text.content.length <= 0
            ) {
              Toast("请输入回复内容");
              return;
            }
            params.hi_content = {
              text: hi_content.text,
            };
            break;
          case "b":
            // if (!hi_content.text || hi_content.text.length <= 0) {
            //   Toast("请输入回复内容");
            //   return;
            // }
            if (t.image_vant.length <= 0) {
              Toast("请上传图片");
              return;
            }
            if (t.image_vant[0].status == "uploading") {
              Toast("图片正在上传，请稍后");
              return;
            }
            if (t.image_vant[0].status == "failed") {
              Toast("图片上传失败，请删除重新上传");
              return;
            }
            if (!t.image_vant[0].path || t.image_vant[0].path.length <= 0) {
              Toast("请上传图片");
              return;
            }
            hi_content.image = {
              media_path: t.image_vant[0].path,
            };
            params.hi_content = {
              text: hi_content.text,
              image: hi_content.image,
            };
            break;
          default:
            if (!hi_content.link) {
              Toast("请设置图文回复内容");
              return;
            }
            if (!hi_content.link.title || hi_content.link.title.length <= 0) {
              Toast("请输入图文链接标题");
              return;
            }
            if (!hi_content.link.desc || hi_content.link.title.desc <= 0) {
              Toast("请输入图文链接描述");
              return;
            }
            if (!hi_content.link.url || hi_content.link.url.length <= 0) {
              Toast("请输入图文链接地址");
              return;
            }
            if (!/^https{0,1}:\/\//i.test(hi_content.link.url)) {
              Toast("链接地址必须是以http://或https://开头");
              return;
            }
            if (t.link_vant.length <= 0) {
              Toast("请上传图片");
              return;
            }
            if (t.link_vant[0].status == "uploading") {
              Toast("图片正在上传，请稍后");
              return;
            }
            if (t.link_vant[0].status == "failed") {
              Toast("图片上传失败，请删除重新上传");
              return;
            }
            if (!t.link_vant[0].path || t.link_vant[0].path.length <= 0) {
              Toast("请上传图片");
              return;
            }
            hi_content.link.picurl = t.link_vant[0].path;
            params.hi_content = {
              text: hi_content.text,
              link: hi_content.link,
            };
            break;
        }
      } else params.hi_content = {};
      var giftconfig = [];
      //奖品设置判断
      for (let index = 0; index < t.giftlist.length; index++) {
        const element = t.giftlist[index];
        if (!element.name) {
          Toast("请设置奖品名称");
          return;
        }
        if (!element.amount) {
          Toast("请设置奖品数量");
          return;
        }
        if (element.type == 1 && !element.winrank) {
          Toast("请设置获奖排名");
          return;
        }
        if (element.type == 2 && !element.wincount) {
          Toast("请设置获奖达标人数");
          return;
        }
        if (!element.winnotice) {
          Toast("请设置中奖通知内容");
          return;
        }
        if (element.image_vant.length > 0) {
          if (element.image_vant[0].status == "uploading") {
            Toast("领奖图片正在上传，请稍后");
            return;
          }
          if (element.image_vant[0].status == "failed") {
            Toast("领奖图片上传失败，请删除重新上传");
            return;
          }
        }
        console.log("element.image_vant", element.image_vant);
        giftconfig.push({
          name: element.name,
          amount: element.amount,
          type: element.type,
          typename: element.typename,
          wincount: element.wincount,
          winrank: element.winrank,
          winnotice: element.winnotice,
          image:
            element.image_vant.length > 0 ? element.image_vant[0].path : "",
          active: element.active,
        });
      }

      //#endregion

      //数据处理
      params.giftconfig = JSON.stringify(giftconfig);
      params.useuser = JSON.stringify(t.useuser.seldatas);
      //   params.auto_firend = params.auto_firend ? 1 : 0;
      //   params.auto_sayhi = params.auto_sayhi ? 1 : 0;
      //   params.auto_tab = params.auto_tab ? 1 : 0;
      params.tab_content = JSON.stringify(t.userTabs.seltag);
      params.hi_content = JSON.stringify(params.hi_content);
      // params.rank_poster =  t.posterupload_result[0].path;
      params.rank_poster = JSON.stringify(t.posterupload_result);
      params.err_image = t.errimage_vant[0].path;

      t.loading_sub = true;
      t.$http
        .post("/Coupon/SaveCoupon", params, 2)
        .then((res) => {
          t.loading_sub = false;
          t.item.coupon_id = res.Data;
          if (res.resultState == 1) {
            if (typeof callback == "function") callback();
            else this.$router.back(-1);
          } else{
              if(res.errorCode == "1001")
                t.$AskBuy(res.errorMsg)
              else Toast(res.errorMsg);
          } 
        })
        .catch((error) => {
          t.loading_sub = false;
          Toast("网络异常，请稍后重试");
        });
    },
    //获得所有的单位
    getallunit() {
      var t = this;
      t.unitloading = true;
      this.$http
        .get("/ManChannel/GetALLUnit", {}, 2)
        .then((res) => {
          t.unitloading = false;
          if (res.resultState == 1) {
            for (let index = 0; index < res.Data.length; index++) {
              const element = res.Data[index];
              t.units.push({ text: element.Text, value: element.Value });
            }
          }
        })
        .catch((error) => {
          t.unitloading = false;
        });
    },
    //获得所有的奖品
    getallgift() {
      var t = this;
      t.gifttypeloading = true;
      this.$http
        .get("/ManChannel/GetALLGift", {}, 2)
        .then((res) => {
          t.gifttypeloading = false;
          if (res.resultState == 1) {
            for (let index = 0; index < res.Data.length; index++) {
              const element = res.Data[index];
              t.gifts.push({ text: element.Text, value: element.Value });
            }
          }
        })
        .catch((error) => {
          t.gifttypeloading = false;
        });
    },
    //选中某个项
    selunit_event(value, index) {
      console.log(value);
      this.item.giftunit = value.value;
      this.selunit = false;
    },
    //选中某个项
    selgifttype_event(value, index) {
      console.log(value);
      this.item.gifttype = value.value;
      this.selgifttype = false;
    },
    getdetail(id) {
      var t = this;
      this.$http
        .get("/Coupon/GetCouponDetail", { couponid: id }, 2)
        .then((res) => {
          t.firstloading = true;
          if (res.resultState == 1) {
            var has_img = 1;
            var has_link = 1;
            var item = res.Data;
            item.hi_content = JSON.parse(item.hi_content);
            if (!item.hi_content.text) item.hi_content.text = { content: "" };
            if (!item.hi_content.image) {
              has_img = 0;
              item.hi_content.image = {
                media_path: "",
              };
            }
            if (!item.hi_content.link) {
              has_link = 0;
              item.hi_content.link = {
                title: "",
                picurl: "",
                desc: "",
                url: "",
                default: 1,
              };
            }
            t.hi_content_tab = "a";
            if (has_img == 1) {
              t.hi_content_tab = "b";
              t.image_vant = [
                {
                  url: `${config.img_host}${item.hi_content.image.media_path}`,
                  status: "",
                  message: "",
                  path: item.hi_content.image.media_path,
                },
              ];
            }
            if (has_link == 1) {
              t.hi_content_tab = "c";
              t.link_vant = [
                {
                  url: `${config.img_host}${item.hi_content.link.picurl}`,
                  status: "",
                  message: "",
                  path: item.hi_content.link.picurl,
                },
              ];
            }
            item.tab_content = JSON.parse(item.tab_content);
            t.useuser.seldatas = JSON.parse(item.useuser || "[]");
            t.userTabs.seltag = item.tab_content;

            t.posterupload_result = [
              {
                url: `${config.img_host}${item.rank_poster}`,
                status: "",
                message: "",
                path: item.rank_poster,
              },
            ];
            try {
              t.posterupload_result = JSON.parse(item.rank_poster);
            } catch {
              t.posterupload_result = null;
            }

            t.errimage_vant = [
              {
                url: `${config.img_host}${item.err_image}`,
                status: "",
                message: "",
                path: item.err_image,
              },
            ];

            var giftlist = JSON.parse(item.giftconfig || "[]");
            for (let index = 0; index < giftlist.length; index++) {
              var type = t.gifttype_actions.find(
                (x) => x.id == giftlist[index].type
              );
              giftlist[index].typename = type ? type.name : "";
              giftlist[index].image_vant = [];
              if (giftlist[index].image) {
                giftlist[index].image_vant = [
                  {
                    url: `${config.img_host}${giftlist[index].image}`,
                    status: "",
                    message: "",
                    path: giftlist[index].image,
                  },
                ];
              }
            }
            t.giftlist = giftlist;
            t.item = item;
          }
        })
        .catch((error) => {
          t.firstloading = true;
        });
    },
    clickpreview(e) {
      ImagePreview({
        images: [e.url],
        closeable: true,
        closeOnPopstate: true,
      });
      console.log("clickpreview", e);
    },

    //图片格式校验
    beforeRead(file) {
      console.log("beforeRead", file);
      if (file.size > 4 * 1024 * 1024) {
        Toast("图片大小不能超过4M");
        return false;
      }
      if (file.type.indexOf("image") < 0) {
        Toast("只能上传图片格式");
        return false;
      }
      return true;
    },
    //上传图片
    afterRead(file_obj, detail) {
      var t = this;
      var file = file_obj.file;
      //设置加载状态
      file_obj.status = "uploading";
      //更换一个随机名称
      var suffix = ".jpg";
      if (file.name.lastIndexOf(".") >= 0)
        suffix = file.name.substr(file.name.lastIndexOf("."));
      var filename = `${newname()}${suffix}`;
      //开始上传
      t.cos_upload(
        //文件保存的路径和名称
        `/${filename}`,
        //文件内容
        file,
        //上传成功后回调函数
        function (err, res) {
          console.log("upload res:", res);
          console.log("upload err:", err);
          if (err) {
            file_obj.status = "failed";
            file_obj.message = "上传失败";
          } else {
            file_obj.status = "";
            file_obj.url = res.Location;
            file_obj.path = res.path;
            // if(detail.name=="imager_vantuploader") t.dis.hi_content.image.media_path = res.Location;
            // else t.dis.hi_content.link.picurl = res.Location;
          }
        },
        //上传进度更新函数
        function (res) {
          console.log("当前进度：", res);
        }
      );
    },
    //图片格式校验
    beforeRead_poster(file) {
      console.log("beforeRead", file);
      if (file.size > 4 * 1024 * 1024) {
        Toast("图片大小不能超过4M");
        return false;
      }
      if (file.type.indexOf("image") < 0) {
        Toast("只能上传图片格式");
        return false;
      }
      return true;
    },
    //上传图片
    afterRead_poster(file_obj, detail) {
      console.log("file_obj", file_obj);
      console.log("detail", detail);
      var t = this;
      if (t.posterupload_loading) return;
      var file = file_obj.file;
      t.posterupload_loading = true;
      //设置加载状态
      file_obj.status = "uploading";
      //更换一个随机名称
      var suffix = ".jpg";
      if (file.name.lastIndexOf(".") >= 0)
        suffix = file.name.substr(file.name.lastIndexOf("."));
      var filename = `${newname()}${suffix}`;
      //开始上传
      t.cos_upload(
        //文件保存的路径和名称
        `/${filename}`,
        //文件内容
        file,
        //上传成功后回调函数
        function (err, res) {
          console.log("upload res:", res);
          console.log("upload err:", err);
          t.posterupload_wait = [file_obj];
          t.posterupload_loading = false;
          if (err) {
            file_obj.status = "failed";
            file_obj.message = "上传失败";
          } else {
            file_obj.status = "";
            file_obj.url = res.Location;
            file_obj.path = res.path;
            // if(detail.name=="imager_vantuploader") t.dis.hi_content.image.media_path = res.Location;
            // else t.dis.hi_content.link.picurl = res.Location;
          }
        },
        //上传进度更新函数
        function (res) {
          console.log("当前进度：", res);
        }
      );
    },
    //选择时间
    seltime(type) {
      this.vanttime_item = type;
      this.vanttime_show = true;
      if (this.vanttime_item == 1) {
        this.nowDate = new Date(this.item.coupon_begindate);
      } else if (this.vanttime_item == 2) {
        this.nowDate = new Date(this.item.coupon_expdate);
      }
    },
    vanttime_confirm(value) {
      console.log("value", value);
      var t = this;
      if (t.vanttime_item == 1) {
        this.item.coupon_begindate = t.dateformat(
          "Y-m-d H:i:s",
          value.valueOf()
        );
      } else if (t.vanttime_item == 2) {
        this.item.coupon_expdate = t.dateformat("Y-m-d H:i:s", value.valueOf());
      }
      this.vanttime_show = false;
    },
    vanttime_cancel() {
      this.vanttime_show = false;
    },

    //打开海报上传的窗体
    poseter_module() {
      if (this.posterupload_result) {
        console.log("has poster info");
        localStorage.setItem(
          "poster.config",
          JSON.stringify(this.posterupload_result)
        );
      } else {
        console.log("no poster info");
        localStorage.removeItem("poster.config");
      }
      this.posterupload_show = true;
    },
    poster_module_enter(res) {
      this.posterupload_result = res;
      this.posterupload_show = false;
    },
    //打开海报上传的窗体
    poseter_go() {
      this.posterupload_wait = this.posterupload_result;
      this.posterupload_show = true;
    },
    //取消上传海报
    poster_cancel() {
      this.posterupload_show = false;
    },
    //确认上传海报
    poster_enter() {
      if (
        this.posterupload_wait &&
        this.posterupload_wait.length > 0 &&
        !this.posterupload_wait[0].status
      ) {
        this.posterupload_result = this.posterupload_wait;
        this.posterupload_show = false;
      } else {
        this.$Toast("还没上传海报哦");
      }
    },
    //获得企业外部联系人所有标签
    GetAllClientTags() {
      var t = this;
      t.$http
        .get("/Channel/GetAllClientTags", {}, 2)
        .then((res) => {
          var usertabs = [];
          if (res.resultState == 1) {
            usertabs = res.Data;
          }
          t.userTabs.datas = usertabs;
        })
        .catch((error) => {});
    },

    //获得部门下的所有部门
    getDeptObj(deptid) {
      var t = this;
      deptid = deptid || 1;
      this.$http
        .get("/Firm/GetDeptObj", { deptid: deptid || 1 }, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.hasdept = true;
          }
        })
        .catch((error) => {});
    },

    //获得拥有外部联系权限的用户信息
    GetFollowUserList() {
      var t = this;
      var useuser_data = [];
      this.$http
        .get("/Channel/GetFollowUserInfoList", {}, 2)
        .then((res) => {
          t.useuser.loading = true;
          if (res.resultState == 1) {
            // useuser_data = useuser_data.concat(res.Data);
            // t.useuser_data = useuser_data;
            t.useuser.datas = res.Data;
          }
        })
        .catch((error) => {});
    },

    //点击选择使用人
    seluseuserEvent() {
      this.useuser_sel = true;
      this.useuser.isdefault = this.isdefault;
    },
    //确认选择使用人
    useuser_sel_confirm(value) {
      var t = this;
      t.useuser_sel = false;
      t.item.useuser = value;
    },
  },
  components: { wx_tags, wx_users, wx_usersn, wx_poster },
  computed: {
    //选中项的单位名称
    getunitname() {
      var t = this;
      var ret = "";
      for (let i = 0; i < t.units.length; i++) {
        var info = t.units.find((item) => item.value == t.item.giftunit);
        console.log("info", info);
        if (info) {
          ret = info.text;
          break;
        }
      }
      return ret;
    },
    //选中项的类型
    getgiftname() {
      var t = this;
      var ret = "";
      for (let i = 0; i < t.gifts.length; i++) {
        var info = t.gifts.find((item) => item.value == t.item.gifttype);
        console.log("info", info);
        if (info) {
          ret = info.text;
          break;
        }
      }
      return ret;
    },
    getTabName() {
      var t = this;
      var ret = "";
      for (let i = 0; i < t.userTabs.seltag.length; i++) {
        for (let j = 0; j < t.userTabs.datas.length; j++) {
          for (let s = 0; s < t.userTabs.datas[j].tag.length; s++) {
            if (t.userTabs.datas[j].tag[s].id == t.userTabs.seltag[i]) {
              ret += `[${t.userTabs.datas[j].group_name}]${t.userTabs.datas[j].tag[s].name}`;
              break;
            }
          }
        }
        if (i < t.userTabs.seltag.length - 1) ret += "，";
      }
      return ret;
    },
    getUserName() {
      var t = this;
      var ret = "";
      if (t.useuser.seldatas) {
        for (let i = 0; i < t.useuser.seldatas.length; i++) {
          var userinfo = t.useuser.datas.find(
            (item) => item.userid == t.useuser.seldatas[i]
          );
          console.log("userinfo", userinfo);
          if (userinfo) ret += userinfo.name;
          if (i < t.useuser.seldatas.length - 1) ret += "，";
        }
      }
      return ret;
    },
  },
  created() {
    var t = this;
    if (t.$route.query.id) t.getdetail(t.$route.query.id);
    else t.firstloading = true;
    t.getDeptObj(0);
    t.$http
      .get("/Firm/GetConfig", {}, 2)
      .then((res) => {
        if (res.resultState == 1) {
          if (!res.Data.Secret) {
            Dialog.confirm({
              title: "系统提示",
              message: "未进行开发配置，需要先配置才能正常创建渠道哦~",
              confirmButtonText: "现在去设置",
              cancelButtonText: "一会再去",
            })
              .then(() => {
                console.log("confirm success");
                window.location.href = "./#/?page=corsettle";
              })
              .catch(() => {
                t.GetFollowUserList();
                t.GetAllClientTags();
              });
          } else {
            t.GetFollowUserList();
            t.GetAllClientTags();
          }
        } else {
          Toast(res.errorMsg);
          setTimeout(() => {
            t.$router.back(-1);
          }, 2000);
        }
      })
      .catch((error) => {
        console.log("error", error);
        // Toast("网络异常，请刷新后重试");
        // setTimeout(() => {
        //   t.$router.back(-1);
        // }, 2000);
      });
    t.userTabs.confimEvent = function () {
      t.userTabs_sel = false;
    };
    t.useuser.closeModal = function () {
      t.useuser_sel = false;
    };
    // t.getallunit();
    // t.getallgift();
  },
  mounted() {},
};
</script>

<style scoped lang="scss" src="../../../static/scss/mcoupon/detail.scss"></style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->